import { render } from "./DeleteUserAccount.vue?vue&type=template&id=05b8526c"
import script from "./DeleteUserAccount.vue?vue&type=script&lang=js"
export * from "./DeleteUserAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__